import { Field } from "./field";

export class OverrideRule {
  id: number; 
  months: number; 
  gender: string; 
  brandId: number;
  brandName: string;
  campaignTypeName: string;
  campaignTypeId: number;
  storeLocationId: number;
  storeLocationName: number;
  ageRangeId: number;
  ageRangeName: string;
  fields: Array<Field> = [];
  priority: number;
  custom1: string;
  custom2: string;
  custom3: string;
  custom4: string;
  custom5: string;
  startDate: string;
  endDate: string;
}
